import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';

const QuoteInput = () => {
  const { quoteId = '' } = useParams();
  const decodedId = quoteId ? atob(quoteId) : quoteId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});

  const route = 'quote';

  useEffect(() => {
    if (quoteId) {
      setIsEditing(true);
      fetchQuoteDetails();
    }
  }, [quoteId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchQuoteDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.quote}${id}/`, { headers });
      setFormData({
        customer: response.data.customer?.id ?? response.data.customer,
        status: response.data.status?.id ?? response.data.status,
        title: response.data.title,
        valid_from: response.data.valid_from,
        expiration_date: response.data.expiration_date,
        discount_type: response.data.discount_type,
        discount_amount: response.data.discount_amount,
        tax_rate: response.data.tax_rate,
        notes: response.data.notes,
        terms_and_conditions: response.data.terms_and_conditions,
        assigned_to: response.data.assigned_to?.id ?? response.data.assigned_to,
        line_items: response.data.line_items?.map(item => item.product?.id ?? item.product) ?? [],
      });
    } catch (error) {
      console.error('Error fetching quote details:', error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const url = quoteId
      ? `${API_DOMAIN}${API_ROUTES.quote}${id}/`
      : `${API_DOMAIN}${API_ROUTES.quote}`;

    try {
      if (quoteId) {
        await axios.put(url, formData, { headers });
      } else {
        await axios.post(url, formData, { headers });
      }
      alert(isEditing ? 'Quote updated successfully!' : 'Quote created successfully!');
    } catch (error) {
      console.error('Error saving quote:', error);
      alert('An error occurred while saving the quote.');
    }
  };

  const quoteFields = [
    { name: 'quote_number', label: 'Quote Number', type: 'text' },
    { name: 'title', label: 'Quote Title', type: 'text' },
    {
      name: 'customer', label: 'Customer', type: 'async-select',
      endpoint: API_ROUTES.customer,
      getOptionLabel: (c) => c.name,
    },
    {
      name: 'status', label: 'Status', type: 'async-select',
      endpoint: API_ROUTES.quoteStatuses,
      getOptionLabel: (s) => s.name,
    },
    { name: 'valid_from', label: 'Valid From', type: 'date' },
    { name: 'expiration_date', label: 'Expiration Date', type: 'date', dateConstraint: 'future' },
    {
      name: 'discount_type', label: 'Discount Type', type: 'select',
      options: [
        { value: '', label: '— None —' },
        { value: 'percentage', label: 'Percentage (%)' },
        { value: 'fixed', label: 'Fixed Amount' },
      ],
    },
    { name: 'discount_amount', label: 'Discount Amount', type: 'number' },
    { name: 'tax_rate', label: 'Tax Rate (%)', type: 'number' },
    {
      name: 'assigned_to', label: 'Assigned To', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
    { name: 'notes', label: 'Notes', type: 'textarea' },
    { name: 'terms_and_conditions', label: 'Terms & Conditions', type: 'textarea' },
    {
      name: 'line_items',
      label: 'Line Items (Products)',
      type: 'async-multiselect',
      endpoint: API_ROUTES.products,
      getOptionLabel: (p) => p.name,
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Quote' : 'Create Quote'}</h1>
      <FormComponent fields={quoteFields} initialFormData={formData} onSubmit={handleSubmit} route={route} />
    </div>
  );
};

export default QuoteInput;
